/** Date parsing for common bank-export formats. */

const MONTHS: Record<string, number> = {
  jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
  jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
};

function mkDate(y: number, mo: number, d: number): Date | null {
  if (mo < 0 || mo > 11 || d < 1 || d > 31) return null;
  const date = new Date(y, mo, d);
  return isNaN(date.getTime()) ? null : date;
}

export function parseDate(input: string | undefined, dayFirst = false): Date | null {
  if (!input) return null;
  const s = input.trim();

  // ISO: 2026-07-05 or 2026/07/05
  let m = s.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (m) return mkDate(+m[1]!, +m[2]! - 1, +m[3]!);

  // Numeric: 07/05/2026, 5-7-26, 05.07.2026
  m = s.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{2,4})$/);
  if (m) {
    const a = +m[1]!;
    const b = +m[2]!;
    let y = +m[3]!;
    if (y < 100) y += 2000;
    let month: number, day: number;
    if (a > 12) { day = a; month = b; }
    else if (b > 12) { month = a; day = b; }
    else if (dayFirst) { day = a; month = b; }
    else { month = a; day = b; }
    return mkDate(y, month - 1, day);
  }

  // "Jul 5, 2026" / "July 5 2026"
  m = s.match(/^([a-z]{3,9})\.?\s+(\d{1,2}),?\s+(\d{4})$/i);
  if (m) {
    const mo = MONTHS[m[1]!.slice(0, 3).toLowerCase()];
    if (mo != null) return mkDate(+m[3]!, mo, +m[2]!);
  }

  // "5 Jul 2026"
  m = s.match(/^(\d{1,2})\s+([a-z]{3,9})\.?\s+(\d{4})$/i);
  if (m) {
    const mo = MONTHS[m[2]!.slice(0, 3).toLowerCase()];
    if (mo != null) return mkDate(+m[3]!, mo, +m[1]!);
  }

  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

/** Detect day-first convention: any date whose first numeric part exceeds 12. */
export function detectDayFirst(rows: string[][], dateIdx: number): boolean {
  for (const r of rows) {
    const m = String(r[dateIdx] ?? '')
      .trim()
      .match(/^(\d{1,2})[-/.](\d{1,2})[-/.]\d{2,4}$/);
    if (m) {
      if (+m[1]! > 12) return true;
      if (+m[2]! > 12) return false;
    }
  }
  return false;
}
